import { Box, Container, Typography } from "@mui/material"


export const Imprint = () => {
    return (
        <Container sx={{ justifyContent: "center", bgcolor: "#FAFAFB", py: 5 }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant='h4' fontWeight={"bold"}>
                    Impressum
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Kontaktdaten</b>
                </Typography>
                <Typography>
                    <b>Kanzlei im Recht</b>
                </Typography>
                <Typography>
                    Rechtsanwältin <b>Burcu Özcan-Ergün</b>
                </Typography>
            </Box>
            <Box sx={{}}>
                <Typography sx={{}}>
                    Wannerstraße 23-25
                </Typography>
                <Typography>
                    44694 Herne
                </Typography>
            </Box>
            <Box sx={{ mt: 1 }}>
                <Typography sx={{}}>
                    Tel. (Büro): 02325 952640
                </Typography>
                <Typography>
                    Tel. (Mobil): 0152 02016852
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Gesetzliche Berufsbezeichnung</b>
                </Typography>
                <Typography>
                    Die Berufsträgerin ist als „Rechtsanwältin“ in der Bundesrepublik Deutschland zugelassen.
                </Typography>
                <Typography sx={{ mt: 1 }}>
                    <b>Informationen nach § 2 DL-InfoV:</b>
                </Typography>
                <Typography>
                    Die genannten gesetzlichen Berufsbezeichnungen “Rechtsanwalt” bzw.
                    “Rechtsanwältin” sowie Fachanwaltsbezeichnungen wurden sämtlich in der Bundesrepublik Deutschland verliehen.

                    Die Berufsträgerin ist als „Rechtsanwältin“ in der Bundesrepublik Deutschland zugelassen,
                    zur Rechtsberatung in Europa befugt und Mitglied der zuständigen Rechtsanwaltskammer als Zulassungs- und Aufsichtsbehörde.
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Zuständige Aufsichtsbehörden</b>
                </Typography>
                <Typography>
                    Rechtsanwaltskammer für den Oberlandesgerichtsbezirk Hamm
                </Typography>
                <Typography>
                    Ostenallee 18,
                    59063 Hamm
                </Typography>
                <Typography>
                    Telefon +49 2381 985000
                </Typography>
                <Typography>
                    E-Mail   info@rak-hamm.de
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Berufsrechtliche Regelungen</b>
                </Typography>
                <Typography>
                    Für die Rechtsanwälte von „Kanzlei im Recht“ gelten im wesentlichen folgende berufsrechtliche Regelungen:
                </Typography>
                <ul>
                    <li>
                        die Bundesrechtsanwaltsordnung (BRAO)
                    </li>
                    <li>
                        die Berufsordnung der Rechtsanwälte (BORA)
                    </li>
                    <li>
                        das Gesetz über die Vergütung der Rechtsanwältinnen und Rechtsanwälte (Rechtsanwaltsvergütungsgesetz – RVG)
                    </li>
                    <li>
                        die Fachanwaltsordnung (FAO)
                    </li>
                    <li>
                        die Berufsregeln der Rechtsanwälte der Europäischen Gemeinschaft (CCBE-Berufsregeln)
                    </li>
                </ul>
                <Typography>
                    Diese berufsrechtlichen Regelungen können auf den Internet-Seiten der Bundesrechtsanwaltskammer unter http://www.brak.de abgerufen werden.
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Berufshaftpflichtversicherung</b>
                </Typography>
                <Typography textAlign={"justify"}>
                    Die Rechtsanwälte von der „Kanzlei im Recht“ unterhalten die 
                    erforderliche Berufshaftpflichtversicherung bei der Ergo Versicherungs AG, 40198 Versicherung

                    Der räumliche Geltungsbereich des Versicherungsschutzes umfasst Tätigkeiten in den 
                    Mitgliedsländern der Europäischen Union und genügt mindestens den Anforderungen des § 1 BRAO.
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Online-Streitbeilegung und Verbraucherstreitbeilegung</b>
                </Typography>
                <Typography textAlign={"justify"}>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit, die unter
                    <a href="http://ec.europa.eu/consumers/odr">http://ec.europa.eu/consumers/odr</a> abrufbar ist.<br /><br />

                    Die Online-Streitbeilegungsplattform (kurz „OS-Plattform“) als Anlaufstelle für Verbraucher und Unternehmer,
                    welche aus online geschlossenen Rechtsgeschäften erwachsene Streitigkeiten außergerichtlich beilegen möchten,
                    ist unter dem folgendem Link erreichbar: <a href="http://ec.europa.eu/consumers/odr">http://ec.europa.eu/consumers/odr</a><br /><br />

                    Zuständige Verbraucherschlichtungsstelle in Deutschland für vermögensrechtliche Streitigkeiten aus einem
                    Mandatsverhältnis ist die Schlichtungsstelle der Rechtsanwaltschaft, Rauchstraße 26, 10787 Berlin,
                    <a href='www.schlichtungsstelle-der-rechtsanwaltschaft.de'>www.schlichtungsstelle-der-rechtsanwaltschaft.de</a>.<br /><br />

                    Bei Streitigkeiten zwischen Rechtsanwälten und ihren Auftraggebern besteht auf Antrag die Möglichkeit der
                    außergerichtlichen Streitschlichtung bei der regionalen Rechtsanwaltskammer Berlin
                    (gemäß § 73 Abs. 2 Nr. 3 i.V.m. § 73 Abs. 5 BRAO) oder bei der Schlichtungsstelle der Rechtsanwaltschaft
                    (§ 191f BRAO) bei der Bundesrechtsanwaltskammer, im Internet zu finden über die Homepage der Bundesrechtsanwaltskammer
                    (<a href='www.brak.de'>www.brak.de</a>), E-Mail: schlichtungsstelle@s-d-r.org
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Haftung für Inhalte</b>
                </Typography>
                <Typography textAlign={"justify"}>
                    Die auf dieser Website und die über diese Website aufrufbaren Inhalte in den sozialen Netzwerken 
                    (Facebook, Google, Xing, LinkedIn, Instagram, TikTok, Threads, Pinterest, YouTube,…) stellen keine 
                    ausdrückliche Rechtsberatung dar. Jegliche Haftung im Zusammenhang mit der Nutzung von Inhalten dieser 
                    Website und die über diese Website aufrufbaren Inhalte in den sozialen Netzwerken oder dem Vertrauen auf 
                    deren Richtigkeit ist ausgeschlossen. Die Kanzlei übernimmt keine Gewähr für die Vollständigkeit und 
                    Richtigkeit der eingestellten Informationen.
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Interessenskonflikt</b>
                </Typography>
                <Typography textAlign={"justify"}>
                    Die Wahrnehmung widerstreitender Interessen ist Rechtsanwälten aufgrund berufsrechtlicher Regelungen 
                    untersagt (§ 43a Abs. 4 BRAO). Vor Annahme eines Mandates wird deshalb immer geprüft, ob ein Interessenkonflikt vorliegt.
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Anwendbares Recht</b>
                </Typography>
                <Typography>
                    Die rechtlichen Hinweise auf dieser Seite sowie alle Fragen und Streitigkeiten im Zusammenhang mit dieser 
                    Webseite und den über diese Website aufrufbaren Seiten in den sozialen Netzwerken unterliegen dem Recht der Bundesrepublik Deutschland. 
                </Typography>
            </Box>
            <Box sx={{ mt: 5 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    <b>Datenschutz</b>
                </Typography>
                <Typography>
                    Diese Webseite nutzt Cookies zur Bereitstellung der vollumfänglichen Funktionalität.
                    Alle Informationen finden Sie in unserer <a href='/Datenschutz'>Datenschutzerklärung</a>
                </Typography>
            </Box>
        </Container>
    )
}